import React, { Component } from 'react';
import PAA from '../PhoneAndAddress';
import styles from './index.css';
import MyIcons from '../../blocks/MyIcons'
import MyLinkOut from '../../blocks/MyLinkOut'
import classNames from 'classnames'
import {LangChangeEventContext} from '../../contexts/LangContext';

// import AOS from 'aos/dist/aos.js'; 
// import 'aos/dist/aos.css';
// 
    // data-aos="fade-up" data-aos-offset="50" 
  

export default class Main extends Component {
  componentWillMount(){
    document.documentElement.scrollTop = 0;
  }
  componentDidMount(){
    // AOS.init({once:true, startEvent: 'DOMContentLoaded'})
  }
  render() {
    return (
      <LangChangeEventContext.Consumer>
        {({lang}) =>(
          <div className={classNames(styles['index'],this.props.classStyle)}  >    
            <div className={styles['dec']} 
                // data-aos="fade-up" data-aos-offset="50" 
              >
              <div className={styles['left']} ></div>
              <div className={styles['right']} ></div>
            </div>

            <div className={styles['soc']} 
                // data-aos="fade-up" data-aos-offset="50" 
              >
                <MyLinkOut classStyle={styles.socLink} to="https://www.facebook.com/dante.moscow/">
                  <MyIcons icon='fb'/>
                </MyLinkOut>
                <a href='/' className={classNames(styles['logoWrapper'])} >  
                  <img alt="" src="/assets/logo.jpg" className={styles['logoImg']} />  
                </a>
                <MyLinkOut classStyle={styles.socLink} to="https://www.instagram.com/dante_moscow/">
                  <MyIcons icon='ins'/>
                </MyLinkOut>
            </div>
            <div className={styles['paa']} 
                // data-aos="fade-up" data-aos-offset="50" 
              >
              <PAA classStyle={styles['paaStyle']} iconPlace='place' iconPhone='phone' colorStyle="black"/>     
            </div>
          </div>
        )}
      </LangChangeEventContext.Consumer>
    );
  }
}




// WEBPACK FOOTER //
// ./src/blocks/FooterMobile/index.js